import { Component, Input, NgModule } from '@angular/core';
import { GitUiDisplayComponent } from '../git-path-mapper';

// a temporary component for POC
@Component({
  selector: 'y42-git-ui-display-mock',
  template: `<div class="p-3 border">
    TableJobDisplay dedicated component for path <strong>{{ path }}</strong>
  </div>`,
})
export class GitUiDisplayMockComponent extends GitUiDisplayComponent {
  @Input() path!: string;
}

@NgModule({
  declarations: [GitUiDisplayMockComponent],
})
export class GitUiDisplayMockModule {}
